import { render, staticRenderFns } from "./DialogCreateNewChat.vue?vue&type=template&id=4fa5d944&scoped=true&"
import script from "./DialogCreateNewChat.vue?vue&type=script&lang=ts&"
export * from "./DialogCreateNewChat.vue?vue&type=script&lang=ts&"
import style0 from "./DialogCreateNewChat.vue?vue&type=style&index=0&id=4fa5d944&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5d944",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSnackbar,VTextField})
